import { render } from "./CalendarMonth.vue?vue&type=template&id=8da8b17e&scoped=true"
import script from "./CalendarMonth.vue?vue&type=script&lang=js"
export * from "./CalendarMonth.vue?vue&type=script&lang=js"

import "./CalendarMonth.vue?vue&type=style&index=0&id=8da8b17e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da8b17e"]])

export default __exports__